import { ProgramService } from "@adfenix/types";
import { HqConfig } from "@adfenix/types/dist/generated/config-service";

export const getDefaultDeltaTemplate = (
  percentageOfTotalBudget: number
): ProgramService.DeltaCampaignTemplateModel => ({
  name: "",
  durationDays: 0,
  landingPageOption: "PropertyPage",
  percentageOfTotalBudget,
  allowOrderWithCustomLandingPage: false,
  allowCustomLocation: false,
  selectedImageTemplates: [],
  externalDeltaTemplateId: ""
});

export const getDefaultMetaTemplate = (
  percentageOfTotalBudget: number
): ProgramService.MetaCampaignTemplateModel => ({
  name: "",
  durationDays: 0,
  landingPageOption: "PropertyPage",
  reconfigurationDelayInHours: 0,
  reconfiguration: false,
  reconfigurationInstructions: "",
  availableImageTemplates: [],
  availableContentTemplates: [],
  availableAdTypes: [],
  percentageOfTotalBudget,
  allowOrderWithCustomLandingPage: false,
  targetingSettings: [],
  allowCustomLocation: false,
  overrideCustomerAdTypeSettings: false
});

export const getDefaultCustomTemplate = (
  hq?: HqConfig
): ProgramService.CustomCampaignTemplateModel => ({
  name: "",
  channel: "Unknown",
  durationDays: 0,
  invoicedByExternalParty: true,
  estimatedExternalPartyPrice: {
    amount: 0,
    currency: (hq?.currency as ProgramService.Currencies | undefined) ?? "SEK"
  },
  emails: [],
  tickets: []
});
